<template>
  <q-row class="row">
    <div
      style="width: 30%"
      :style="columnStyle"
    >
      <div class="q-toolbar">
        <div class="q-toolbar-buttons">
          <q-button
            class="q-toolbar-btn"
            @click="newParentMenu"
          >
            <font-awesome-icon :icon="['fas', 'plus']"/>
          </q-button>
          <q-button
            class="q-toolbar-btn"
            @click="refreshMenus"
          >
            <font-awesome-icon :icon="['fas', 'sync-alt']"/>
          </q-button>
          <q-input
            v-model="filterText"
            :placeholder="this.$qt('menuEditor.searchPlaceHolder')"
          >
            <q-button
              slot="append"
              type="info"
              icon="q-icon-search"
            />
          </q-input>
        </div>
      </div>

      <q-menu-bar
        class="q-menu-vertical-Dash menu-tree"
        :router="false"
        :menus="menus"
        :is-collapse="false"
        width="400"
        fore-color="black"
        active-text-color="red"
        @item-select="menuSelected"
      />
    </div>

    <div
      style="width: 70%;"
      :style="columnStyle"
    >
      <q-json>{{ currentMenu }}</q-json>
<!--      <menu-detail-->
<!--        v-if="currentMenu"-->
<!--        v-model="currentMenu"-->
<!--        @saved-model="created"-->
<!--        @update-model="updated"-->
<!--        @remove-model="removed"-->
<!--      />-->
    </div>
  </q-row>
</template>

<script>
  // import menuDetail from "./menuDetail";

  export default {
    name: "QMenuTree",
    components: {
      // 'menu-detail': menuDetail
    },
    data() {
      return {
        filterText: '',
        menus: [],
        defaultProps: {
          children: 'children',
          label: 'caption'
        },
        currentMenu: undefined,
      }
    },
    computed: {
      columnStyle() {
        let ret = {};
        ret.float = this.$isRtl ? 'right' : 'left';
        ret.boxSizing = 'border-box';

        return ret;
      },
    },
    watch: {
      filterText(val) {
        this.$refs.treeMenus.filter(val);
      }
    },
    created() {
      // actions.callService('qasedak', 'GetEditableMenusInTree', {}).then((res) => {
      //   this.menus = res.models;
      // }).catch(() => {
      //
      // });


      this.menus = [
        {
          index: '1',
          icon: 'envelope-open-text',
          caption: 'Message & Tasks',
          groups: [
            {
              caption: 'Message',
              members: [
                {
                  index: '/dashboard/messages',
                  icon: 'inbox',
                  caption: 'Inbox',
                },
                {
                  index: '2-3',
                  icon: null,
                  caption: 'Sent',
                }
              ]
            }
          ]
        },
        {
          index: '2',
          icon: 'archway',
          caption: 'Nouri',
          children: [
            {
              index: '2-2',
              icon: null,
              caption: 'Amin',
              children: [
                {
                  index: '2-2-1',
                  icon: null,
                  caption: 'Niusha',
                  groups: [
                    {
                      caption: 'Pets',
                      members: [
                        {
                          index: '2-2',
                          icon: null,
                          caption: 'Joli',
                        },
                        {
                          index: '2-3',
                          icon: null,
                          caption: 'Jili',
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    methods: {
      menuSelected() {
      },
      newParentMenu() {
      },
      refreshMenus() {
      },
      makeNew(node, data) {
        this.currentMenu = {
          xxx: node,
          parentNode: data,
          parent: data.id
        };
      },
      created(data) {
        let parent = data.parent;
        let model = data.model;

        if (!parent.children) {
          parent.children = [];
        }

        parent.children.push(model);
        this.currentMenu = model;
      },
      updated(data) {
        this.currentMenu = data;
      },
      edit(node, data) {
        this.currentMenu = data;
        this.currentMenu.parentNode = node.parent;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.caption.indexOf(value) !== -1;
      },
      removed(data) {
        let parent = data.parent;
        let model = data.model;

        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === model.id);
        children.splice(index, 1);
        this.currentMenu = undefined;
      },
      submitNewForm() {
        // actions.callService('qasedak', 'CreateMenu', this.menuModel).then((res) => {
        //   // this.$router.replace(this.$route.query.redirect || '/');
        // }).catch(() => {
        //   return false;
        // });
      }
    }
  }
</script>

<style scoped>
  .row {
    padding: 15px;
  }

  .q-toolbar {
    margin-bottom: 15px;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    /*margin-left: 3px;*/
    /*margin-right: 3px;*/
  }

  .menu-tree {
    border: 1px solid #cfdbe2;
    border-radius: 4px;
  }

  .q-menu-vertical-Dash:not(.q-menu--collapse) {
    width: 100%;
    min-height: 400px;
    height: auto
  }
</style>